const addTogglePrevNextLinksActive = (emblaApi, prevBtn, nextBtn) => {
  const togglePrevNextLinksState = () => {
    if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');
    else prevBtn.setAttribute('disabled', 'disabled');

    if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');
    else nextBtn.setAttribute('disabled', 'disabled');
  };

  emblaApi
    .on('select', togglePrevNextLinksState)
    .on('init', togglePrevNextLinksState)
    .on('reInit', togglePrevNextLinksState);

  return () => {
    prevBtn.removeAttribute('disabled');
    nextBtn.removeAttribute('disabled');
  };
};

// @todo make an util, also, this function isn't really necessary
export const addPrevNextLinksClickHandlers = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev();
  };
  const scrollNext = () => {
    emblaApi.scrollNext();
  };
  prevBtn.addEventListener('click', scrollPrev, false);
  nextBtn.addEventListener('click', scrollNext, false);

  const removeTogglePrevNextLinksActive = addTogglePrevNextLinksActive(
    emblaApi,
    prevBtn,
    nextBtn,
  );

  return () => {
    removeTogglePrevNextLinksActive();
    prevBtn.removeEventListener('click', scrollPrev, false);
    nextBtn.removeEventListener('click', scrollNext, false);
  };
};

export default addPrevNextLinksClickHandlers;
